module.exports = __webpack_public_path__ + "img/381-83ef25.png";